
// H5美途保游戏
export const HDBX0501001 = 'HDBX0501001';
export const HDBX0501002 = 'HDBX0501002';

// 首页
export const BX010001 = 'BX010001';
export const BX010002 = 'BX010002';
export const BX010003 = 'BX010003';
export const BX010004 = 'BX010004';
export const BX010005 = 'BX010005';
export const BX010006 = 'BX010006';
export const BX010007 = 'BX010007';
export const BX010008 = 'BX010008';
export const BX010009 = 'BX010009';
export const BX010010 = 'BX010010';
export const BX010011 = 'BX010011';
export const BX010012 = 'BX010012';
export const BX010013 = 'BX010013';
export const BX010014 = 'BX010014';
export const BX010015 = 'BX010015';
export const BX010016 = 'BX010016';
export const BX010017 = 'BX010017';
export const BX010018 = 'BX010018';
export const BX010019 = 'BX010019';
export const BX010020 = 'BX010020';

// 产品列表页
export const BX020001 = 'BX020001';
export const BX020002 = 'BX020002';

// 发现页
export const BX030001 = 'BX030001';
export const BX030002 = 'BX030002';
export const BX030003 = 'BX030003';
export const BX030004 = 'BX030004';
export const BX030005 = 'BX030005';
export const BX030006 = 'BX030006';
export const BX030007 = 'BX030007';

// 个人中心
export const BX040001 = 'BX040001';
export const BX040002 = 'BX040002';
export const BX040003 = 'BX040003';
export const BX040004 = 'BX040004';
export const BX040005 = 'BX040005';
export const BX040006 = 'BX040006';
export const BX040007 = 'BX040007';
export const BX040008 = 'BX040008';

// 产品详情页
export const BX050001 = 'BX050001';
export const BX050002 = 'BX050002';
export const BX050003 = 'BX050003';
export const BX050004 = 'BX050004';

// 在线投保
export const BX060001 = 'BX060001';
export const BX060002 = 'BX060002';
export const BX060003 = 'BX060003';
export const BX060004 = 'BX060004';
export const BX060005 = 'BX060005';
export const BX060006 = 'BX060006';
export const BX060007 = 'BX060007';
export const BX060008 = 'BX060008';
export const BX060009 = 'BX060009';

// App 引流
export const BX070001 = 'BX070001';
export const BX070002 = 'BX070002';

// 续保页
export const BX080001 = 'BX080001';
export const BX080002 = 'BX080002';
export const BX080003 = 'BX080003';
export const BX080004 = 'BX080004';
export const BX080005 = 'BX080005';

export const TD = [
    // H5美途保游戏
    {
        eventId: HDBX0501001,
        eventName:'活动首页，点击开始',
        eventLabel(value) {
            return typeof value === 'string'? value: '';
        },
        eventParmas(id) {
            return {
                id,
                eventName: '点击开始',
                adPosition: '输入昵称下方点击开始按钮',
                rootPosition: '活动首页'
            };
        }
    },
    {
        eventId: HDBX0501002,
        eventName:'测试结果页，领取美途保按钮',
        eventLabel(value) {
            return typeof value === 'string'? value: '';
        },
        eventParmas(id) {
            return {
                id,
                eventName: '点击领取',
                adPosition: '页面底部领取美途保按钮',
                rootPosition: '测试结果页'
            };
        }
    },
    // 首页
    {
        eventId: BX010001,
        eventLabel(value) {
            return `${value.title}`;
        },
        eventParmas(id) {
            return {
                id,
                eventName: '顶部产品推荐按钮点击',
                adPosition: '顶部产品推荐',
                rootPosition: '顶部产品推荐'
            };
        }
    },
    {
        eventId: BX010002,
        eventLabel(value) {
            return `Banner轮播图-${value.index}-${value.title}`;
        },
        eventParmas(id) {
            return {
                id,
                eventName: 'Banner轮播图',
                adPosition: 'Banner轮播图',
                rootPosition: '顶部banner'
            };;
        }
    },
    {
        eventId: BX010003,
        eventLabel(value) {
            return `Icon分类-${value.categoryId}`;
        },
        eventParmas(id) {
            return {
                id,
                eventName: 'Icon分类图标切换',
                adPosition: 'Icon分类',
                rootPosition: ''
            };;
        }
    },
    {
        eventId: BX010004,
        eventLabel(value) {
            return `Icon分类-${value.categoryId}-${value.name}`;
        },
        eventParmas(id) {
            return {
                id,
                eventName: 'Icon分类产品点击',
                adPosition: 'Icon分类'
            };;
        }
    },
    {
        eventId: BX010005,
        eventLabel(value) {
            return `Icon分类-${value.categoryId}`;
        },
        eventParmas(id) {
            return {
                id,
                eventName: 'Icon分类更多',
                adPosition: 'Icon分类'
            };;
        }
    },
    {
        eventId: BX010006,
        eventLabel(value) {
            return `${value.where}-${value.categoryId}-${value.name}`;
        },
        eventParmas(id) {
            return {
                id,
                eventName: 'Icon分类产品列表产品点击',
                adPosition: 'Icon分类'
            };;
        }
    },
    {
        eventId: BX010007,
        eventLabel(value) {
            return `身份特质-${value.id}`;
        },
        eventParmas(id) {
            return {
                id,
                eventName: '身份特质点击',
                adPosition: '身份特质',
                rootPosition: '身份特质'
            };;
        }
    },
    {
        eventId: BX010008,
        eventLabel(value) {
            return `${value.where}-${value.name}`;
        },
        eventParmas(id) {
            return {
                id,
                eventName: '身份特质产品列表产品点击',
                adPosition: '身份特质二级页面',
                rootPosition: '身份特质'
            };;
        }
    },
    {
        eventId: BX010009,
        eventLabel(value) {
            return `${value.name}`;
        },
        eventParmas(id) {
            return {
                id,
                eventName: '国美专享产品',
                adPosition: '国美专享',
                rootPosition: '国美专享'
            };;
        }
    },
    {
        eventId: BX010010,
        eventLabel(value) {
            return typeof value === 'string'? value: '';
        },
        eventParmas(id) {
            return {
                id,
                eventName: '国美专享更多',
                adPosition: '国美专享',
                rootPosition: '国美专享'
            };;
        }
    },
    {
        eventId: BX010011,
        eventLabel(value) {
            return `国美专享-${value.name}`;
        },
        eventParmas(id) {
            return {
                id,
                eventName: '国美专享产品列表产品点击',
                adPosition: '国美专享二级页面',
                rootPosition: '国美专享'
            };;
        }
    },
    {
        eventId: BX010012,
        eventLabel(value) {
            return `${value.name}`;
        },
        eventParmas(id) {
            return {
                id,
                eventName: '特惠精选产品',
                adPosition: '特惠精选',
                rootPosition: '特惠精选'
            };;
        }
    },
    {
        eventId: BX010013,
        eventLabel(value) {
            return typeof value === 'string'? value: '';
        },
        eventParmas(id) {
            return {
                id,
                eventName: '特惠精选更多',
                adPosition: '特惠精选',
                rootPosition: '特惠精选'
            };
        }
    },
    {
        eventId: BX010014,
        eventLabel(value) {
            return `特惠精选-${value.name}`;
        },
        eventParmas(id) {
            return {
                id,
                eventName: '特惠精选产品列表产品点击',
                adPosition: '特惠精选二级页面',
                rootPosition: '特惠精选'
            };
        }
    },
    {
        eventId: BX010015,
        eventLabel(value) {
            return `${value.title}-${value.index}`;
        },
        eventParmas(id) {
            return {
                id,
                eventName: '小保说Banner',
                adPosition: '小保说',
                rootPosition: '小保说'
            };
        }
    },
    {
        eventId: BX010016,
        eventLabel(value) {
            return typeof value === 'string'? value: '';
        },
        eventParmas(id) {
            return {
                id,
                eventName: '小保说更多',
                adPosition: '小保说',
                rootPosition: '小保说'
            };
        }
    },
    {
        eventId: BX010017,
        eventLabel(value) {
            return typeof value === 'string'? value: '';
        },
        eventParmas(id) {
            return {
                id,
                eventName: '点击首页',
                adPosition: '首页',
                rootPosition: '底部导航'
            };
        }
    },
    {
        eventId: BX010018,
        eventLabel(value) {
            return typeof value === 'string'? value: '';
        },
        eventParmas(id) {
            return {
                id,
                eventName: '点击产品',
                adPosition: '产品',
                rootPosition: '底部导航'
            };
        }
    },
    {
        eventId: BX010019,
        eventLabel(value) {
            return typeof value === 'string'? value: '';
        },
        eventParmas(id) {
            return {
                id,
                eventName: '点击发现',
                adPosition: '发现',
                rootPosition: '底部导航'
            };
        }
    },
    {
        eventId: BX010020,
        eventLabel(value) {
            return typeof value === 'string'? value: '';
        },
        eventParmas(id) {
            return {
                id,
                eventName: '点击我的',
                adPosition: '我的',
                rootPosition: '底部导航'
            };
        }
    },
    {
        eventId: BX020001,
        eventLabel(value) {
            return `${value.id}`;
        },
        eventParmas(id) {
            return {
                id,
                eventName: '产品分类切换',
                adPosition: '产品列表页',
                rootPosition: '产品列表页'
            };
        }
    },
    {
        eventId: BX020002,
        eventLabel(value) {
            return `${value.productCatesId}-${value.name}`;
        },
        eventParmas(id) {
            return {
                id,
                eventName: '产品点击',
                adPosition: '产品列表页',
                rootPosition: '产品列表页'
            };
        }
    },
    {
        eventId: BX030001,
        eventLabel(value) {
            return `${value.name}-${value.index}`;
        },
        eventParmas(id) {
            return {
                id,
                eventName: 'Banner轮播图',
                adPosition: 'Banner轮播图',
                rootPosition: '发现页'
            };
        }
    },
    {
        eventId: BX030002,
        eventLabel(value) {
            return typeof value === 'string'? value: '';
        },
        eventParmas(id) {
            return {
                id,
                eventName: '点击预约咨询',
                adPosition: '预约咨询',
                rootPosition: '发现页'
            };
        }
    },
    {
        eventId: BX030003,
        eventLabel(value) {
            return typeof value === 'string'? value: '';
        },
        eventParmas(id) {
            return {
                id,
                eventName: '点击体检预约',
                adPosition: '体检预约',
                rootPosition: '发现页'
            };
        }
    },
    {
        eventId: BX030004,
        eventLabel(value) {
            return typeof value === 'string'? value: '';
        },
        eventParmas(id) {
            return {
                id,
                eventName: '点击境外救援',
                adPosition: '境外救援',
                rootPosition: '发现页'
            };
        }
    },
    {
        eventId: BX030005,
        eventLabel(value) {
            return typeof value === 'string'? value: '';
        },
        eventParmas(id) {
            return {
                id,
                eventName: '点击齿科服务',
                adPosition: '齿科服务',
                rootPosition: '发现页'
            };
        }
    },
    {
        eventId: BX030006,
        eventLabel(value) {
            return `${value.id}-${value.index}`;
        },
        eventParmas(id) {
            return {
                id,
                eventName: 'Icon分类切换',
                adPosition: 'Icon分类',
                rootPosition: '发现页'
            };
        }
    },
    {
        eventId: BX030007,
        eventLabel(value) {
            return `${value.id}-${value.articleId}`;
        },
        eventParmas(id) {
            return {
                id,
                eventName: '保险小课堂列表文章点击',
                adPosition: '保险小课堂',
                rootPosition: '发现页'
            };
        }
    },
    {
        eventId: BX040001,
        eventLabel(value) {
            return typeof value === 'string'? value: '';
        },
        eventParmas(id) {
            return {
                id,
                eventName: '我的理财',
                adPosition: '我的理财',
                rootPosition: '个人中心'
            };
        }
    },
    {
        eventId: BX040002,
        eventLabel(value) {
            return typeof value === 'string'? value: '';
        },
        eventParmas(id) {
            return {
                id,
                eventName: '保障中',
                adPosition: '我的保障',
                rootPosition: '个人中心'
            };
        }
    },
    {
        eventId: BX040003,
        eventLabel(value) {
            return typeof value === 'string'? value: '';
        },
        eventParmas(id) {
            return {
                id,
                eventName: '已失效',
                adPosition: '我的保障',
                rootPosition: '个人中心'
            };
        }
    },
    {
        eventId: BX040004,
        eventLabel(value) {
            return typeof value === 'string'? value: '';
        },
        eventParmas(id) {
            return {
                id,
                eventName: '待支付',
                adPosition: '我的保障',
                rootPosition: '个人中心'
            };
        }
    },
    {
        eventId: BX040005,
        eventLabel(value) {
            return typeof value === 'string'? value: '';
        },
        eventParmas(id) {
            return {
                id,
                eventName: '全部保障',
                adPosition: '我的保障',
                rootPosition: '个人中心'
            };
        }
    },
    {
        eventId: BX040006,
        eventLabel(value) {
            return typeof value === 'string'? value: '';
        },
        eventParmas(id) {
            return {
                id,
                eventName: '我的权益',
                adPosition: '我的权益',
                rootPosition: '个人中心'
            };
        }
    },
    {
        eventId: BX040007,
        eventLabel(value) {
            return typeof value === 'string'? value: '';
        },
        eventParmas(id) {
            return {
                id,
                eventName: '点击常用联系人',
                adPosition: '常用联系人',
                rootPosition: '个人中心'
            };
        }
    },
    {
        eventId: BX040008,
        eventLabel(value) {
            return typeof value === 'string'? value: '';
        },
        eventParmas(id) {
            return {
                id,
                eventName: '添加常用联系人',
                adPosition: '常用联系人列表',
                rootPosition: '个人中心'
            };
        }
    },
    {
        eventId: BX050001,
        eventLabel(value) {
            return typeof value === 'string'? value: '';
        },
        eventParmas(id) {
            return {
                id,
                eventName: '立即投保',
                adPosition: '产品详情页',
                rootPosition: '产品详情页'
            };
        }
    },
    {
        eventId: BX050002,
        eventLabel(value) {
            return `${value.name}-${value.index}`;
        },
        eventParmas(id) {
            return {
                id,
                eventName: '保障分类tab切换',
                adPosition: '保障分类',
                rootPosition: '产品详情页'
            };
        }
    },
    {
        eventId: BX050003,
        eventLabel(value) {
            return `${value.name}-${value.index}`;
        },
        eventParmas(id) {
            return {
                id,
                eventName: '内容分类tab切换',
                adPosition: '内容分类',
                rootPosition: '产品详情页'
            };
        }
    },
    {
        eventId: BX050004,
        eventLabel(value) {
            return `${value.name}`;
        },
        eventParmas(id) {
            return {
                id,
                eventName: '条款阅读',
                adPosition: '产品详情页',
                rootPosition: '产品详情页'
            };
        }
    },
    {
        eventId: BX060001,
        eventLabel(value) {
            return typeof value === 'string'? value: '';
        },
        eventParmas(id) {
            return {
                id,
                eventName: '全部为否',
                adPosition: '健康告知',
                rootPosition: '在线投保'
            };
        }
    },
    {
        eventId: BX060002,
        eventLabel(value) {
            return typeof value === 'string'? value: '';
        },
        eventParmas(id) {
            return {
                id,
                eventName: '全部为是',
                adPosition: '健康告知',
                rootPosition: '在线投保'
            };
        }
    },
    {
        eventId: BX060003,
        eventLabel(value) {
            return typeof value === 'string'? value: '';
        },
        eventParmas(id) {
            return {
                id,
                eventName: '常用联系人',
                adPosition: '投保信息填写页',
                rootPosition: '在线投保'
            };
        }
    },
    {
        eventId: BX060004,
        eventLabel(value) {
            return typeof value === 'string'? value: '';
        },
        eventParmas(id) {
            return {
                id,
                eventName: '相关条款',
                adPosition: '投保信息填写页',
                rootPosition: '在线投保'
            };
        }
    },
    {
        eventId: BX060005,
        eventLabel(value) {
            return typeof value === 'string'? value: '';
        },
        eventParmas(id) {
            return {
                id,
                eventName: '立即投保',
                adPosition: '投保信息填写页',
                rootPosition: '在线投保'
            };
        }
    },
    {
        eventId: BX060006,
        eventLabel(value) {
            return typeof value === 'string'? value: '';
        },
        eventParmas(id) {
            return {
                id,
                eventName: '确认支付',
                adPosition: '收银台',
                rootPosition: '在线投保'
            };
        }
    },
    {
        eventId: BX060007,
        eventLabel(value) {
            return typeof value === 'string'? value: '';
        },
        eventParmas(id) {
            return {
                id,
                eventName: '查看保单',
                adPosition: '投保结果页面',
                rootPosition: '在线投保'
            };
        }
    },
    {
        eventId: BX060008,
        eventLabel(value) {
            return typeof value === 'string'? value: '';
        },
        eventParmas(id) {
            return {
                id,
                eventName: '返回首页',
                adPosition: '投保结果页面',
                rootPosition: '在线投保'
            };
        }
    },
    {
        eventId: BX060009,
        eventLabel(value) {
            return typeof value === 'string'? value: '';
        },
        eventParmas(id) {
            return {
                id,
                eventName: '返回产品详情',
                adPosition: '投保结果页面',
                rootPosition: '在线投保'
            };
        }
    },
    {
        eventId: BX070001,
        eventLabel(value) {
            return typeof value === 'string'? value: '';
        },
        eventParmas(id) {
            return {
                id,
                eventName: '点击“立即购买”',
                adPosition: '立即购买按钮',
                rootPosition: 'H5产品详情页'
            };
        }
    },
    {
        eventId: BX070002,
        eventLabel(value) {
            return typeof value === 'string'? value: '';
        },
        eventParmas(id) {
            return {
                id,
                eventName: '前往投保成功页',
                adPosition: '投保成功页',
                rootPosition: 'H5投保成功页'
            };
        }
    },




    {
        eventId: BX080001,
        eventLabel(value) {
            return typeof value === 'string'? value: '';
        },
        eventParmas(id) {
            return {
                id,
                eventName: '点击续保按钮',
                adPosition: '保单详情页',
                rootPosition: '保单详情页'
            };
        }
    },
    {
        eventId: BX080003,
        eventLabel(value) {
            return typeof value === 'string'? value: '';
        },
        eventParmas(id) {
            return {
                id,
                eventName: '续保按钮前往续保页面',
                adPosition: '续保页',
                rootPosition: '续保页'
            };
        }
    },
    {
        eventId: BX080004,
        eventLabel(value) {
            return typeof value === 'string'? value: '';
        },
        eventParmas(id) {
            return {
                id,
                eventName: '微信模版消息前往续保页面',
                adPosition: '续保页',
                rootPosition: '续保页'
            };
        }
    },
    {
        eventId: BX080005,
        eventLabel(value) {
            return typeof value === 'string'? value: '';
        },
        eventParmas(id) {
            return {
                id,
                eventName: '短信前往续保页面',
                adPosition: '续保页',
                rootPosition: '续保页'
            };
        }
    },
    {
        eventId: BX080002,
        eventLabel(value) {
            return typeof value === 'string'? value: '';
        },
        eventParmas(id) {
            return {
                id,
                eventName: '点击立即投保按钮',
                adPosition: '续保页',
                rootPosition: '续保页'
            };
        }
    },
];



// WEBPACK FOOTER //
// ./src/constants/TDAPP.js